(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-interactions"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__productCardCartBound) return;
    window.__productCardCartBound = true;

    const cartRoot = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');

    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((badge) => {
        if (count > 0) {
          badge.textContent = count;
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      });
    }

    function bindAddToCart(scope) {
      (scope || document).querySelectorAll('[data-product-add-to-cart]').forEach((button) => {
        if (button.dataset.bound === 'true') return;
        button.dataset.bound = 'true';

        button.addEventListener('click', async () => {
          const variantId = button.dataset.variantId;
          if (!variantId || button.disabled) return;

          button.classList.add('is-loading');

          try {
            const response = await fetch(`${cartRoot}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: 1 }),
            });

            if (!response.ok) throw new Error('Add to cart failed');

            const cart = await fetch(`${cartRoot}cart.js`).then((res) => res.json());
            updateCartCount(cart.item_count);

            if (typeof window.refreshCartDrawer === 'function') {
              await window.refreshCartDrawer();
            }

            window.openCartDrawer?.();
          } catch (error) {
            console.error(error);
          } finally {
            button.classList.remove('is-loading');
          }
        });
      });
    }

    bindAddToCart();

    window.bindProductCardAddToCart = bindAddToCart;

    document.addEventListener('shopify:section:load', (event) => {
      bindAddToCart(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
